import { create } from "zustand";

export const useSiteMeta = create((set) => ({
  speakerMeta: null,
  setSpeakerMeta: (updater) =>
    set((state) => ({
      speakerMeta:
        typeof updater === "function" ? updater(state.speakerMeta) : updater,
    })),

  sponsorMeta: null,
  setSponsorMeta: (updater) =>
    set((state) => ({
      sponsorMeta:
        typeof updater === "function" ? updater(state.sponsorMeta) : updater,
    })),

  venueMeta: null,
  setVenueMeta: (updater) =>
    set((state) => ({
      venueMeta:
        typeof updater === "function" ? updater(state.venueMeta) : updater,
    })),

  contactMeta: null,
  setContactMeta: (updater) =>
    set((state) => ({
      contactMeta:
        typeof updater === "function" ? updater(state.contactMeta) : updater,
    })),
}));
